import {handleActions} from 'redux-actions';
import {Record, List} from 'immutable';

import * as Actions from './actions';

const LinkContactModalState = Record({
    simpleIsVisible: false,
    institutionId: undefined,
    saving: false,
    searchResults: List(),
    selectedIndex: 0,
    billPayer: undefined,
    suggestions: List(),
    fetchingSuggestions: false,
});

const primaryBillingContactModalReducer = handleActions(
    {
        [Actions.showSimple.type]: (state, {payload}) =>
            state.merge({
                simpleIsVisible: true,
                institutionId: payload.institutionId,
                billPayer: payload.billPayer,
            }),
        [Actions.searchRelationSuccess.type]: (state, {payload}) =>
            state.merge({
                searchResults: payload.searchResults,
            }),
        [Actions.hide.type]: () => new LinkContactModalState(),
        [Actions.selectionChanged.type]: (state, {payload}) => state.merge({selectedIndex: payload.index}),
        [Actions.updateSimple.type]: state => state.merge({saving: true}),
        [Actions.updateSimpleFailed.type]: state => state.merge({saving: false}),
        [Actions.updateSimpleSuccess.type]: () => new LinkContactModalState(),
        [Actions.fetchSuggestions.type]: state => state.merge({fetchingSuggestions: true}),
        [Actions.fetchSuggestionsSuccess.type]: (state, {payload}) =>
            state.merge({fetchingSuggestions: false, suggestions: payload.suggestions}),
        [Actions.fetchSuggestionsFailed]: state => state.merge({fetchingSuggestions: false}),
    },
    new LinkContactModalState(),
);

export default primaryBillingContactModalReducer;
